export const findParentWithAttribute = (element: Element | null) => {
  let maxIterations = 100
  while (
    element &&
    !(
      element.hasAttribute('data-case-detail') ||
      element.hasAttribute('data-case-detail-table') ||
      element.hasAttribute('data-template')
    ) &&
    maxIterations > 0
  ) {
    element = element.parentElement
    maxIterations--
  }

  if (maxIterations === 0) {
    console.warn('findParentWithAttribute reached maximum iteration count')
    return null
  }

  return element
}
